import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'Compré un domingo a la noche. El lunes entré al box con el plan exacto de la semana. Los WODs del Tomo 1 son exactamente lo que necesitaba para mis grupos mezclados de nivel. Nunca más improviso.',
  name: 'Lucas M.',
  location: 'Buenos Aires',
  role: 'Instructor de Crossfit en Box Propio'
}, {
  quote: 'El Tomo 3, el de escalado y adaptaciones, me cambió todo. El primer mes, alumnos que llevaban meses estancados en Scaled dieron el salto a Rx. El protocolo de niveles me da la estructura que antes no tenía.',
  name: 'Martín R.',
  location: 'Rosario',
  role: 'Instructor en Box Comercial'
}, {
  quote: 'El sistema de programación del Tomo 4 es único en el mercado. 12 semanas de fuerza listas para usar, con los porcentajes calculados semana a semana. Antes tardaba horas armando el ciclo. Ahora abro el PDF y en 5 minutos tengo todo listo.',
  name: 'Agustina F.',
  location: 'Córdoba',
  role: 'Instructora de Crossfit Grupal e Individual'
}, {
  quote: 'La Guía de Cues Verbales del Tomo 2 eliminó el silencio incómodo cuando corrijo técnica olímpica. Ahora tengo siempre algo preciso para decir. Mis alumnos me dicen que se sienten mucho más guiados y seguros en el Clean y el Snatch.',
  name: 'Diego P.',
  location: 'Tucumán',
  role: 'Instructor Particular y en Gimnasio'
}, {
  quote: 'La tasa de abandono de mi box bajó muchísimo. Sin cambiar lo que enseño. Solo aplicando el sistema de progresión mensual y la variedad del banco de WODs. Los alumnos ahora quieren venir porque siempre hay algo nuevo.',
  name: 'Romina G.',
  location: 'Mendoza',
  role: 'Instructora de Crossfit Online y Presencial'
}, {
  quote: 'El Banco de 100 WODs me salvó de perder alumnos que venían a probar. Ahora sé exactamente qué programar para una primera clase. Mi tasa de conversión de prueba a membresía subió de manera notable.',
  name: 'Sebastián V.',
  location: 'Santa Fe',
  role: 'Instructor en Box Propio'
}, {
  quote: 'El Crossfit Pro me cambió la cabeza. Nunca había dimensionado el riesgo que corría sin adaptaciones claras para mis alumnos con condiciones especiales. Ahora trabajo con una tranquilidad y un profesionalismo que antes no tenía.',
  name: 'Mariana R.',
  location: 'Salta',
  role: 'Instructora en Centro de Salud y Fitness'
}];
export function LongTestimonials() {
  return <section className="py-12 md:py-24 px-4 bg-cf-dark border-t border-white/5" data-id="element-257">
      <div className="max-w-6xl mx-auto" data-id="element-258">
        <div className="text-center mb-8 md:mb-16" data-id="element-259">
          <h2 className="font-bebas text-3xl md:text-6xl text-white tracking-tight mb-2 md:mb-4 leading-tight" data-id="element-260">
            +500 instructores de Crossfit de todo el país ya tienen su CROSSFIT
            RESUELTO
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" data-id="element-261">
          {testimonials.map((t, i) => <div key={i} className={`bg-cf-card p-5 md:p-8 rounded-xl border border-white/5 flex flex-col justify-between ${i === 6 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-262">
              <div data-id="element-263">
                <div className="flex gap-1 text-cf-gold mb-4 md:mb-6" data-id="element-264">
                  {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-current" data-id="element-265" />)}
                </div>
                <p className="text-sm md:text-base text-gray-300 italic mb-5 md:mb-8 leading-relaxed" data-id="element-266">
                  "{t.quote}"
                </p>
              </div>
              <div className="pt-4 md:pt-6 border-t border-white/10" data-id="element-267">
                <p className="font-bold text-white mb-1 text-sm md:text-base" data-id="element-268">
                  {t.name} — {t.location}
                </p>
                <p className="text-xs md:text-sm text-cf-gold" data-id="element-269">{t.role}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}